import { locales } from '@visa/lib-locale';

export const getSupportedLocales = () => {
  const supportedCountries = window.VISA_GLOBALS?.appSupportedCountries?.split(',') ?? [];
  return locales.locales.filter(
    locale => supportedCountries.length < 1 || supportedCountries.includes(locale.code)
  );
};
